import http from './http'

export default {
  weixin: {
    getWxSetting () {
      return http.get('/weixin/getwxsetting')
    },
    setWxSetting (model) {
      return http.post('/weixin/setwxsetting', model)
    },
    bindAccount (model) {
      return http.post('/weixin/wxuser/bindaccount', model)
    },
    getWxMemberCardSetting () {
      return http.get('/weixin/getwxmembercardsetting')
    },
    setWxMemberCardSetting (model) {
      return http.post('/weixin/setwxmembercardsetting', model)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/weixin.js